import React, { Component } from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import style from './Image.css';
import blankImage from '../../../public/icons/no-image-available.jpg';

class Image extends Component {
  state = {
    imageCount: this.props.image.length || 1
  };

  componentWillReceiveProps(newProps) {
    this.setState({ imageCount: newProps.image.length || 1 });
  }

  handleClick = event => {
    event.preventDefault();
    this.setState({
      imageCount: this.state.imageCount + 1
    });
  };

  handleDelete = (event, idx) => {
    event.preventDefault();
    this.props.deleteImage(idx);
  };

  render() {
    const { image, errorMessage } = this.props;
    return (
      <div className={style.formComponent}>
        <label style={{ fontWeight: 700 }} htmlFor="image">
          <span>Image</span>
        </label>
        <div>
          {Array(this.state.imageCount).fill(0).map((_, idx) =>
            <div className="row" key={`image-${idx}`}>
              <div className="col justify-content-center">
                <div className={style.uploadButtonWrapper}>
                  <div className={style.glyphWrapper}>
                    <i className="fa fa-camera" aria-hidden="true" />
                  </div>
                  <div className={style.imageOverlay}>
                    {image[idx]
                      ? <img
                          alt="activity pic"
                          src={image[idx].photo}
                          className="img-thumbnail"
                        />
                      : <img
                          src={blankImage}
                          className="img-thumbnail"
                          width="100"
                          height="100"
                        />}
                  </div>
                  <input
                    type="file"
                    onChange={event => this.props.onImageChange(event, idx)}
                    name="image"
                    accept="image/*"
                  />
                </div>
                <i
                  title="delete"
                  onClick={event => this.handleDelete(event, idx)}
                  aria-hidden="true"
                  className="fa fa-remove"
                />
              </div>
              {errorMessage &&
                errorMessage[idx] &&
                <div
                  className={cx('alert', 'alert-danger', style.errorMessage)}
                  role="alert"
                >
                  <span
                    className={cx('fa', 'fa-info-circle', style.alertIcon)}
                  />
                  <span>
                    {errorMessage[idx]}
                  </span>
                </div>}
            </div>
          )}
          <button
            type="button"
            className={'btn btn-warning'}
            onClick={this.handleClick}
          >
            More
          </button>
        </div>
      </div>
    );
  }
}

export default withStyles(style)(Image);



// WEBPACK FOOTER //
// ./src/components/Image/Image.js